export const formatExperience = (
  decimalExperience: string | number | undefined
): string => {
  if (decimalExperience === null || decimalExperience === undefined) {
    return "N/A";
  }

  const experience = parseFloat(String(decimalExperience));

  if (isNaN(experience) || experience < 0) {
    return "N/A";
  }

  const years = Math.floor(experience);
  const months = Math.round((experience - years) * 10);

  const total = years * 12 + months;

  if (years > 0 && months > 0) {
    return `${years} ${years > 1 ? "years" : "year"} ${months} ${
      months > 1 ? "months" : "month"
    } (${total} months)`;
  }
  if (years > 0) {
    return `${years} ${years > 1 ? "years" : "year"} (${total} months)`;
  }
  if (months > 0) {
    return `${months} ${months > 1 ? "months" : "month"} (${months} months)`;
  }

  return "Fresher";
};
